import { render, staticRenderFns } from "./RoltekBanner.vue?vue&type=template&id=5c56f3f0&scoped=true"
import script from "./RoltekBanner.vue?vue&type=script&lang=js"
export * from "./RoltekBanner.vue?vue&type=script&lang=js"
import style0 from "./RoltekBanner.vue?vue&type=style&index=0&id=5c56f3f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c56f3f0",
  null
  
)

export default component.exports